import { OrderOperationType } from 'api/types/entity/account/order';
import { isFinanceProject } from 'config';
import { Stack } from 'libs/ui';
import {
  ExecutionPeriodSection,
  ExecutionTermsSection,
  FinancialInstrumentSection,
  SenderOrRecipientDetailsSection,
  ConfirmationDocumentSection,
  TransactionVolumeSection,
  TransferVolumeSection,
  AdditionalParametersSection,
} from 'modules/account/orderModule/common/components/sections';

import { useCreateOrderContext } from '../../providers/OrderProvider';

export const CreateOrderFormContent = () => {
  const { orderType } = useCreateOrderContext();

  const isPurchaseOrSale =
    orderType === OrderOperationType.SecuritiesPurchase ||
    orderType === OrderOperationType.SecuritiesSale;

  const isWithdrawalOrDeposit =
    orderType === OrderOperationType.SecuritiesWithdrawal ||
    orderType === OrderOperationType.SecuritiesDeposit;

  const isFinance = isFinanceProject();

  return (
    <Stack flex={1} spacing={32}>
      <ExecutionPeriodSection />
      <ExecutionTermsSection
        isShowOperationKind={isWithdrawalOrDeposit}
        isShowOperationPurpose={isPurchaseOrSale && isFinance}
        isShowOrderType={isPurchaseOrSale}
        isShowYield={isPurchaseOrSale}
      />
      <FinancialInstrumentSection />
      {isPurchaseOrSale && <TransactionVolumeSection />}
      {isWithdrawalOrDeposit && <TransferVolumeSection />}
      {isWithdrawalOrDeposit && (
        <SenderOrRecipientDetailsSection type="sender" />
      )}
      {isWithdrawalOrDeposit && (
        <SenderOrRecipientDetailsSection type="recipient" />
      )}
      {isWithdrawalOrDeposit && <AdditionalParametersSection />}
      {isWithdrawalOrDeposit && <ConfirmationDocumentSection />}
    </Stack>
  );
};
